module.exports = __webpack_public_path__ + "img/lineup33@2x.1678bf93.png";